import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    avatarUrl: {
      width: '5rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
    },
    // eslint-disable-next-line
    name_en: {
      name: 'ชื่อ (ภาษาอังกฤษ)',
      width: '1fr',
    },
    position: {
      name: 'ตำแหน่ง',
      width: '8rem',
    },
    // eslint-disable-next-line
    position_en: {
      name: 'ตำแหน่ง (ภาษาอังกฤษ)',
      width: '1fr',
    },
    workplace: {
      name: 'สถานที่ทำงาน',
      width: '8rem',
    },
    // eslint-disable-next-line
    workplace_en: {
      name: 'สถานที่ทำงาน (ภาษาอังกฤษ)',
      width: '1fr',
    },
    telephone: {
      name: 'โทรศํพท์',
      width: '8rem',
    },
    email: {
      name: 'อีเมลล์',
      width: '6rem',
    },
    // eslint-disable-next-line
    // created_at: {
    //   name: 'แก้ไขล่าสุด',
    //   width: '6rem',
    // },
    // eslint-disable-next-line
    updated_at: {
      name: 'แก้ไขล่าสุด',
      width: '10rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
  },
  sortable: ['name', 'position', 'workplace', 'name_en', 'position_en', 'workplace_en', 'updated_at'],
};
